export default function PHP_openlog() {
  return (
    <div>
      <h1>PHP_openlog</h1>
    </div>
  );
}
